import React, { useState } from "react";
import FormAlert from "components/forms/FormAlert";
import AuthForm from "components/AuthForm";
import AuthSocial from "components/AuthSocial";
import AuthFooter from "components/AuthFooter";
import { useRouter } from "next/router";

function Auth(props) {
  const router = useRouter();
  const [formAlert, setFormAlert] = useState(null);

  const handleAuth = () => {
    router.push(props.afterAuthPath);
  };

  const handlePhoneEntry = (status, phone) => {
    if (status) {
      let afterAuthPath = props.afterAuthPath
        ? `&next=${props.afterAuthPath}`
        : "";
      router.push(`/auth/otp?ph=${encodeURIComponent(phone)}${afterAuthPath}`);
    } else {
      alert(
        "Something went wrong. Could not verify your phone number. Try again, or contact support@trymycar.com / +370 625 13762."
      );
    }
  };

  const handleFormAlert = (data) => {
    setFormAlert(data);
  };

  return (
    <>
      {formAlert && (
        <FormAlert type={formAlert.type} message={formAlert.message} />
      )}

      <AuthForm
        type={props.type}
        phone={props.phone}
        typeValues={props.typeValues}
        onAuth={handleAuth}
        onPhoneEntry={handlePhoneEntry}
        onFormAlert={handleFormAlert}
      />
    </>
  );
}

export default Auth;
